import base from "../middlewares/interceptors";
import {
  getIssuesDetailURl,
  getIssuesHistoryURl,
  getValidationIssuesDetailPaginatedURl,
  getValidationIssuesDetailURl,
  getValidationIssuesHistoryURl,
  getGenericResearchIssuesDetailPaginatedURl,
  getRuleResearchIssuesDetailPaginatedURl,
  getExecutionIssuesDetailPaginatedURl,
} from "./constants";
import {
  getGenericResearchIssueHistory,
  getRuleResearchIssueHistory,
} from "./ResearchIssuesService";

export const getIssuesDetail = async (payload: any) => {
  try {
    const response = await base.post(`${getIssuesDetailURl}`, payload);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
export const getPaginatedValidationIssuesDetail = async ({
  payload,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    const params = new URLSearchParams({
      page: pageN,
      size: pageS,
      ...Object.entries(payload || {}).reduce((acc: any, [key, value]: any) => {
        if (value !== null && value !== undefined && value !== "")
          acc[key] = value; // ✅ FIXED: Allow 0 but exclude null, undefined, empty string
        return acc;
      }, {}),
    });

    const response = await base.get(
      `${getValidationIssuesDetailPaginatedURl}?${params.toString()}`, // ✅ FIXED: Now only URLSearchParams.toString() encodes once
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPaginatedExecutionIssuesDetail = async ({
  payload,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    const params = new URLSearchParams({
      page: pageN,
      size: pageS,
      ...Object.entries(payload || {}).reduce((acc: any, [key, value]: any) => {
        if (value !== null && value !== undefined && value !== "")
          acc[key] = value; // ✅ FIXED: Allow 0 but exclude null, undefined, empty string
        return acc;
      }, {}),
    });

    const response = await base.get(
      `${getExecutionIssuesDetailPaginatedURl}?${params.toString()}`, // ✅ FIXED: Now only URLSearchParams.toString() encodes once
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
export const getPaginatedRuleResearchIssuesDetail = async ({
  payload,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    const keyMap: Record<string, string> = {
      generic_research_id: "research_query_id",
    };
    const params = new URLSearchParams({
      page: pageN,
      size: pageS,
      ...Object.entries(payload || {}).reduce((acc: any, [key, value]: any) => {
        if (value !== null && value !== undefined && value !== "") {
          // Use mapped key if available, otherwise keep original
          const paramKey = keyMap[key] || key;
          acc[paramKey] = value;
        }
        return acc;
      }, {}),
    });

    const response = await base.get(
      `${getRuleResearchIssuesDetailPaginatedURl}?${params.toString()}`, // ✅ FIXED: Now only URLSearchParams.toString() encodes once
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
export const getPaginatedGenericResearchIssuesDetail = async ({
  payload,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    const keyMap: Record<string, string> = {
      execution_id: "generic_research_query_execution_id",
      generic_research_id: "generic_research_query_id",
    };
    const params = new URLSearchParams({
      page: pageN,
      size: pageS,
      ...Object.entries(payload || {}).reduce((acc: any, [key, value]: any) => {
        if (value !== null && value !== undefined && value !== "") {
          // Use mapped key if available, otherwise keep original
          const paramKey = keyMap[key] || key;
          acc[paramKey] = value;
        }
        return acc;
      }, {}),
    });

    const response = await base.get(
      `${getGenericResearchIssuesDetailPaginatedURl}?${params.toString()}`, // ✅ FIXED: Now only URLSearchParams.toString() encodes once
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
export const getValidationIssuesDetail = async (payload: any) => {
  try {
    const response = await base.post(
      `${getValidationIssuesDetailURl}`,
      payload,
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateExecutionIssues = async (issueId: string, payload: any) => {
  try {
    const response = await base.post(
      `${getIssuesDetailURl}/${issueId}`,
      payload,
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const massExecutionIssuesUpdate = async (payload: any) => {
  try {
    const response = await base.post(
      `${getIssuesDetailURl}/mass_update/`,
      payload,
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
export const getIssueHistory = async (
  issueHistoryId: string,
  issueFrom: string,
) => {
  try {
    let response;
    if (issueFrom === "execution") {
      response = await base.get(`${getIssuesHistoryURl}/${issueHistoryId}`);
    } else if (issueFrom === "ruleResearch") {
      response = await getRuleResearchIssueHistory(parseInt(issueHistoryId));
      return response;
    } else if (issueFrom === "genericResearch") {
      response = await getGenericResearchIssueHistory(parseInt(issueHistoryId));
      return response;
    } else {
      response = await base.get(
        `${getValidationIssuesHistoryURl}/${issueHistoryId}`,
      );
    }
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const upadateValidationIssues = async (
  issueId: string,
  payload: any,
) => {
  try {
    const response = await base.post(
      `${getValidationIssuesDetailURl}/${issueId}`,
      payload,
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const massValidationIssuesUpadate = async (payload: any) => {
  try {
    const response = await base.post(
      `${getValidationIssuesDetailURl}/mass_update/`,
      payload,
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
